export const LoginImage = () => {
  return (
    <svg
      width="198"
      height="281"
      viewBox="0 0 198 281"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114.052 158.379L140.849 174.974L195.389 141.156V107.953L114.052 158.379ZM140.845 177.519C140.656 177.519 140.451 177.453 140.297 177.354L111.308 159.391C110.973 159.176 110.748 158.796 110.748 158.375C110.748 157.941 110.961 157.553 111.308 157.342L195.925 104.879C196.264 104.66 196.678 104.66 197.013 104.879C197.364 105.09 197.569 105.487 197.569 105.904V141.829C197.569 142.263 197.364 142.651 197.013 142.862L141.389 177.354C141.227 177.453 141.038 177.519 140.845 177.519Z"
        fill="#05DBE0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M131.424 101.629L153.933 115.185L164.974 108.5L131.403 88.2886L131.424 101.629ZM153.933 116.211C153.857 116.204 153.777 116.181 153.701 116.14L130.742 102.317C130.602 102.234 130.516 102.071 130.516 101.904L130.502 87.4686C130.502 87.2991 130.586 87.1468 130.731 87.0621C130.866 86.9704 131.038 86.9704 131.175 87.0621L166.105 108.09C166.24 108.173 166.332 108.329 166.332 108.498C166.332 108.668 166.243 108.824 166.105 108.91L154.156 116.14C154.093 116.181 154.018 116.204 153.933 116.211Z"
        fill="#F8B518"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.8679 192.576L13.3587 179.02L2.31806 185.704L35.8891 205.916L35.8679 192.576ZM13.3587 177.994C13.4352 178.001 13.5149 178.023 13.5914 178.065L36.5496 191.887C36.6895 191.97 36.7758 192.133 36.7758 192.301L36.7904 206.736C36.7904 206.905 36.7058 207.058 36.561 207.142C36.426 207.234 36.2535 207.234 36.1168 207.142L1.1873 186.114C1.05226 186.031 0.959551 185.876 0.959551 185.706C0.959551 185.537 1.04901 185.381 1.1873 185.294L13.1358 178.065C13.1993 178.023 13.2741 178.001 13.3587 177.994Z"
        fill="#F8B518"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.24 120.405L127.01 113.797L127.047 107.398L110.986 117.255L116.24 120.405ZM127.414 114.04C127.393 114.072 127.365 114.101 127.33 114.125L116.346 120.866C116.28 120.907 116.195 120.906 116.129 120.866L110.446 117.454C110.379 117.414 110.34 117.341 110.341 117.257C110.338 117.177 110.38 117.102 110.449 117.064L127.159 106.808C127.224 106.768 127.308 106.765 127.375 106.805C127.441 106.845 127.481 106.921 127.482 107.002L127.44 113.926C127.441 113.964 127.432 114.002 127.414 114.04Z"
        fill="#05DBE0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.2977 18.6937L103.068 12.0857L103.105 5.68644L87.0441 15.5434L92.2977 18.6937ZM103.472 12.3287C103.451 12.3604 103.423 12.3899 103.388 12.4134L92.404 19.1541C92.3375 19.1955 92.2527 19.1946 92.1867 19.1548L86.5037 15.7423C86.437 15.7022 86.3976 15.6292 86.3992 15.546C86.3957 15.4653 86.4374 15.3901 86.5065 15.3522L103.217 5.09609C103.282 5.05685 103.366 5.05329 103.432 5.09344C103.499 5.1336 103.539 5.2095 103.539 5.29031L103.498 12.2147C103.499 12.2522 103.49 12.2902 103.472 12.3287Z"
        fill="#EF4161"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.756 76.2116L81.2208 95.6986L65.2625 86.0894L113.786 57.0354L113.756 76.2116ZM81.2208 97.1733C81.3313 97.1634 81.4465 97.1311 81.557 97.0714L114.741 77.2014C114.943 77.082 115.068 76.8482 115.068 76.607L115.089 55.8566C115.089 55.6129 114.967 55.394 114.757 55.2722C114.562 55.1404 114.313 55.1404 114.115 55.2722L63.6281 85.5C63.4329 85.6194 63.2989 85.8432 63.2989 86.0869C63.2989 86.3306 63.4282 86.5545 63.6281 86.6788L80.8986 97.0714C80.9903 97.1311 81.0985 97.1634 81.2208 97.1733Z"
        fill="#EF4161"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M131.357 54.582L153.866 41.0259L164.907 47.7105L131.336 67.922L131.357 54.582ZM153.866 40C153.789 40.0069 153.71 40.0294 153.633 40.0709L130.675 53.8935C130.535 53.9765 130.449 54.1392 130.449 54.307L130.434 68.742C130.434 68.9115 130.519 69.0637 130.664 69.1485C130.799 69.2402 130.971 69.2402 131.108 69.1485L166.037 48.1205C166.172 48.0375 166.265 47.8818 166.265 47.7123C166.265 47.5427 166.176 47.387 166.037 47.3005L154.089 40.0709C154.025 40.0294 153.95 40.0069 153.866 40Z"
        fill="#05DBE0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M122.191 41.0852L106.586 31.511L106.533 22.2391L129.803 36.5207L122.191 41.0852ZM106.001 31.863C106.032 31.909 106.073 31.9517 106.123 31.9857L122.037 41.7523C122.134 41.8122 122.256 41.8109 122.352 41.7533L130.586 36.809C130.683 36.7508 130.74 36.6451 130.738 36.5245C130.743 36.4077 130.682 36.2986 130.582 36.2437L106.371 21.3838C106.276 21.3269 106.155 21.3217 106.058 21.3799C105.962 21.4381 105.904 21.5481 105.903 21.6652L105.964 31.6978C105.962 31.7522 105.976 31.8072 106.001 31.863Z"
        fill="#F8B518"
      />
      <rect x="13.427" y="121.038" width="171.674" height="113" fill="url(#pattern0)" />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_433_5462"
            transform="matrix(0.000893111 0 0 0.00135685 -0.0224699 0)"
          />
        </pattern>
        <image
          id="image0_433_5462"
          width="1170"
          height="737"
          xlinkHref="/img/prisma-card.png"
        />
      </defs>
    </svg>
  );
};
